import React from "react";
import { useNavigate } from "react-router-dom";
import { PeekBox } from "@piiqtechnologies/ui-components";
import { useHomeDestination } from "@hooks";
import { useAuthContext } from "@stores/AuthContext";
/**
 * The Discover logo at the top left of the sidebar. A signed-in user goes to their home — the same
 * place the sidebar's Home row goes — instead of www.peek.us in a new tab, which took them out of
 * the app. Only someone signed out is sent to the marketing site.
 */
export const NavigationLogo = () => {
    const navigate = useNavigate();
    const { user } = useAuthContext();
    const homeDestination = useHomeDestination();
    const handleLogoClick = () => {
        if (user) {
            navigate(homeDestination);
            return;
        }
        window.open("https://www.peek.us/", "_blank", "noreferrer");
    };
    return (React.createElement(PeekBox, { component: "img", sx: {
            width: "100px",
            height: "auto",
            cursor: "pointer",
        }, 
        // @ts-ignore
        src: "/images/peek_discover_dark_logo.svg", alt: "Peek Logo", onClick: handleLogoClick }));
};
export default NavigationLogo;
